import { render, staticRenderFns } from "./UserLimite.vue?vue&type=template&id=f4cc26ec&scoped=true"
import script from "./UserLimite.vue?vue&type=script&lang=js"
export * from "./UserLimite.vue?vue&type=script&lang=js"
import style0 from "./UserLimite.vue?vue&type=style&index=0&id=f4cc26ec&prod&lang=less"
import style1 from "./UserLimite.vue?vue&type=style&index=1&id=f4cc26ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cc26ec",
  null
  
)

export default component.exports